import { Pagination, PageNumber } from './BlogPagination.styles';
import { ArrowRight } from '@/icons/index';
import { useRouter } from 'next/router';
import Link from 'next/link';

interface Props {
  lastPage: number;
}

const BlogPagination = ({ lastPage }: Props) => {
  const { query } = useRouter();
  const page = +(query.page || 1);

  const setHref = (page: number) =>
    `/blog?page=${page}${query.category ? `&category=${query.category}` : ``}`;

  const pageNumbers = () => {
    let pages = [page];
    if (lastPage === 2) {
      if (page === 1) pages = [page, page + 1];
      else pages = [page - 1, page];
    } else {
      if (page === 1) pages = [page, page + 1, page + 2];
      else if (page === lastPage) pages = [page - 2, page - 1, page];
      else pages = [page - 1, page, page + 1];
    }
    return (
      <>
        {pages.map((el) => (
          <Link key={el} href={setHref(el)} passHref>
            <PageNumber active={page === el}>{el}</PageNumber>
          </Link>
        ))}
      </>
    );
  };
  return lastPage !== 1 ? (
    <Pagination disabledBack={page === 1} disabledForward={page === lastPage}>
      <Link href={setHref(page > 1 ? page - 1 : 1)} passHref>
        <a>
          <ArrowRight />
        </a>
      </Link>
      {pageNumbers()}
      <Link href={setHref(page < lastPage ? page + 1 : lastPage)} passHref>
        <a>
          <ArrowRight />
        </a>
      </Link>
    </Pagination>
  ) : null;
};

export default BlogPagination;
